import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const SupplierForm: React.FC<{ 
    viewKey?: string, 
    linkedItem?: { [key: string]: number | string }, 
    searchValue?: string 
}> = ({ 
    viewKey, linkedItem, searchValue
}) => {
    const apiObject = 'contact';

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'contact.general.organization_name_label',
            type: 'text',
            ...(searchValue ? { defaultValue: searchValue } : {}),
            placeholder: 'contact.general.organization_name_placeholder',
        },

        // Remove these fields here for now
        // // Supplier organization fields
        // {
        //     type: 'header',
        //     header: 'Contactpersoon',
        // },
        // {
        //     name: 'organization_person_title',
        //     label: 'person.general.salutation_label',
        //     type: 'text',
        //     placeholder: 'person.general.salutation_placeholder',
        //     group: 'field-row',
        //     width: '35%'
        // },
        // {
        //     name: 'organization_person_first_name',
        //     label: 'person.general.first_name_label',
        //     type: 'text',
        //     placeholder: 'person.general.first_name_placeholder',
        //     group: 'field-row',
        //     width: '65%'
        // },
        // {
        //     name: 'organization_person_last_name',
        //     label: 'person.general.last_name_label',
        //     type: 'text',
        //     placeholder: 'person.general.last_name_placeholder',
        // },
        // {
        //     name: 'organization_person_phone_number',
        //     label: 'person.general.phone_number_label',
        //     type: 'text',
        //     placeholder: 'person.general.phone_number_placeholder',
        // },
        // {
        //     name: 'organization_person_email',
        //     label: 'person.general.email_address_label',
        //     type: 'text',
        //     placeholder: 'person.general.email_address_placeholder',
        // },
        
        // // Address fields
        // {
        //     type: 'header',
        //     header: 'Adres'
        // },
        // {
        //     name: 'street',
        //     label: 'location.general.street_label',
        //     type: 'text',
        //     placeholder: 'location.general.street_placeholder',
        //     group: 'street-row',
        //     width: '70%'
        // },
        // {
        //     name: 'house_number',
        //     label: 'location.general.house_number_label_short',
        //     type: 'text',
        //     placeholder: 'location.general.house_number_placeholder',
        //     group: 'street-row',
        //     width: '30%'
        // },
        // {
        //     name: 'postal_code',
        //     label: 'location.general.postal_code_label',
        //     type: 'text',
        //     placeholder: 'location.general.postal_code_placeholder',
        //     group: 'city-row',
        //     width: '35%'
        // },
        // {
        //     name: 'city',
        //     label: 'location.general.city_label',
        //     type: 'text',
        //     placeholder: 'location.general.city_placeholder',
        //     group: 'city-row',
        //     width: '65%'
        // },
        // {
        //     name: 'country',
        //     label: 'location.general.country_label',
        //     type: 'text',
        //     placeholder: 'location.general.country_placeholder',
        // },
        // {
        //     name: 'name',
        //     label: 'location.general.location_name_label',
        //     type: 'text',
        //     placeholder: 'location.general.location_name_placeholder',
        //     tooltipText: 'location.general.location_name_tooltipText',
        // },
    ];

    console.log("linkedItem", linkedItem)

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
        />
    );
};

export default SupplierForm;